module.exports = __webpack_public_path__ + "media/images/landing/bg/screens-company/02-23095a85b2ae69b5bc6a089b4a5ee0fe.png";